import { useEffect, useState } from 'react';
import { subscribe, type ToastTone } from '../lib/toastBus.js';
import { theme } from '../theme.js';

interface ToastItem {
  id: number;
  message: string;
  tone: ToastTone;
}

export function ToastHost() {
  const [items, setItems] = useState<ToastItem[]>([]);

  useEffect(() => {
    return subscribe((raw, tone) => {
      // Never show an empty pill — say something rather than nothing.
      const message = raw?.trim() || (tone === 'error' ? 'Something went wrong' : 'Done');
      setItems((cur) => {
        if (cur.some((i) => i.message === message)) return cur;
        const id = Date.now() + Math.random();
        setTimeout(() => {
          setItems((cur2) => cur2.filter((i) => i.id !== id));
        }, 5000);
        return [...cur, { id, message, tone }];
      });
    });
  }, []);

  if (items.length === 0) return null;

  return (
    <div style={{
      position: 'fixed', bottom: 20, left: '50%', transform: 'translateX(-50%)',
      display: 'flex', flexDirection: 'column', gap: 8, zIndex: 1000,
      width: '100%', maxWidth: 400, padding: '0 16px', pointerEvents: 'none',
    }}>
      {items.map((item) => {
        const tone = item.tone === 'success' ? theme.status.ok : theme.status.danger;
        return (
        <div key={item.id} role="status" style={{
          background: tone.bg, color: tone.fg,
          border: `1px solid ${tone.fg}33`,
          padding: '12px 16px', borderRadius: 10, fontSize: 14, fontWeight: 500,
          boxShadow: '0 8px 24px rgba(0,0,0,0.16)', fontFamily: theme.font,
          pointerEvents: 'auto',
        }}>
          {item.message}
        </div>
        );
      })}
    </div>
  );
}
